/**
 * Profile Sidebar Module
 * Автоматическая прокрутка к активному элементу навигации при загрузке страницы
 */
class ProfileSidebar {
  constructor(element) {
    this.element = element;
    this.nav = element.querySelector('.profile-sidebar__nav');
    this.init();
  }

  init() {
    if (!this.nav) {
      return;
    }

    // Прокручиваем к активному элементу при загрузке страницы
    this.scrollToActive();
  }

  scrollToActive() {
    const activeItem = this.nav.querySelector('.profile-sidebar__nav-item.active');

    if (!activeItem) {
      return;
    }

    // Небольшая задержка для полного рендеринга
    setTimeout(() => {
      // Проверяем, есть ли горизонтальный скролл (на мобильных устройствах)
      const hasHorizontalScroll = this.nav.scrollWidth > this.nav.clientWidth;

      if (!hasHorizontalScroll) {
        return; // Нет скролла, не нужно прокручивать
      }

      // Вычисляем позицию активного элемента относительно контейнера
      const navRect = this.nav.getBoundingClientRect();
      const activeRect = activeItem.getBoundingClientRect();

      // Вычисляем смещение для центрирования активного элемента
      const scrollLeft = activeItem.offsetLeft - (this.nav.clientWidth / 2) + (activeItem.offsetWidth / 2);

      // Прокручиваем с плавной анимацией
      this.nav.scrollTo({
        left: Math.max(0, scrollLeft), // Убеждаемся, что значение не отрицательное
        behavior: 'smooth'
      });
    }, 100); // Небольшая задержка для полного рендеринга
  }
}

// Auto-initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  const profileSidebars = document.querySelectorAll('.profile-sidebar');
  profileSidebars.forEach(sidebar => {
    new ProfileSidebar(sidebar);
  });
});

export default ProfileSidebar;

